export enum SystemKey {
    Patent = 'patent',
    Lucky15 = 'lucky15',
    Lucky31 = 'lucky31',
    Lucky63 = 'lucky63',
    Trixie = 'trixie',
    Yankee = 'yankee',
    Canadian = 'canadian',
    Heinz = 'heinz',
    SuperHeinz = 'superheinz',
    Goliath = 'goliath',

    MOfN = 'mofn',
    BankerSingles = 'systembankersingles',
}
